import { render, staticRenderFns } from "./GlobalAudio.vue?vue&type=template&id=a0cd99b6&scoped=true"
import script from "./GlobalAudio.vue?vue&type=script&lang=js"
export * from "./GlobalAudio.vue?vue&type=script&lang=js"
import style0 from "@/styles/components/GlobalAudio/GlobalAudio.less?vue&type=style&index=0&id=a0cd99b6&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cd99b6",
  null
  
)

export default component.exports